<template>
    <div>
        <my-header
            :title="resource.title"
            height="50px"
            isBack
        />
        <div style="position: relative;width: 100%;height: calc(100vh - 50px);">
            <pdf ref="pdf" v-for="i in pageNow" :key="i"
                :src="url" :page="i"
            />
            <!-- 加载中 -->
            <div class="mask" v-if="!success">
                <van-empty description="">
                    <van-loading size="24px" vertical>加载中...</van-loading>
                </van-empty>
            </div>
        </div>
    </div>
</template>

<script>
import pdf from 'vue3-pdf'
import MyHeader from "@/components/myHeader";
import {getResource} from "@/api/CommonApi";
import AddPointMixin from "@/views/resource/AddPointMixin";

export default {
    name: 'PDF',
    components: {
        MyHeader,
        pdf
    },
    mixins:[AddPointMixin],
    props:{
        id:{
            type:String,
            required:true,
        }
    },
    watch:{
        id(){
            this.loadResource()
        }
    },
    data() {
        return {
            // 资源
            resource:{},
            // 是否加载中
            loading:false,
            url:'',
            timer: null,
            pageNow: 0,
            pageAll: 0,
            success: false
        }
    },
    mounted() {
        this.loadResource()// 加载数据
        window.addEventListener('scroll', this.listenBottomOut)
    },
    unmounted() {
        clearTimeout(this.timer)
        window.removeEventListener('scroll',this.listenBottomOut)
    },
    computed:{
        pdfUrl(){
            const r = this.resource
            const firstItem = r.firstItem
            if(!firstItem) return ''
            return firstItem.content
        }
    },
    methods: {
        loadResource(){
            if(this.loading) return;
            this.resource = {}
            this.loading = true
            this.url = ''
            this.pageNow = 0
            this.pageAll = 0
            this.success = false
            getResource(this.id,{fetchContent:true}).then(res => {
                this.resource = res.result
                // 初始化PDF
                this.initPdf()
            }).finally(() => {
                this.loading = false
            })
        },
        initPdf() {
            this.url = pdf.createLoadingTask({
                url: this.pdfUrl,
                // CMapReaderFactory
                cMapUrl: '/cmaps/',
                cMapPacked: true
            })

            this.pageNow = 2

            this.url.promise.then(pdf => {
                this.pageAll = pdf.numPages
                this.success = true
            }).catch((err) => {
                console.error(err)
            })
        },

        //触底触发函数
        listenBottomOut () {
            if(!this.success){
                return
            }
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            let clientHeight = document.documentElement.clientHeight;
            let scrollHeight = document.documentElement.scrollHeight;
            if (scrollTop + 2 * clientHeight >= scrollHeight) {
                this.loadPages()
            }
        },

        loadPages() {
            if(this.pageNow + 5 <= this.pageAll) {
                this.pageNow += 5
            }else{
                this.pageNow = this.pageAll
            }
        },
    }
}
</script>

<style scoped>
.mask{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    align-items: center;
}
.start{
    top:30vh;
}
.now{
    top:53vh;
}
</style>
